import { render } from "./ModalNewTicket.vue?vue&type=template&id=827a97c8&scoped=true"
import script from "./ModalNewTicket.vue?vue&type=script&lang=js"
export * from "./ModalNewTicket.vue?vue&type=script&lang=js"

import "./ModalNewTicket.vue?vue&type=style&index=0&id=827a97c8&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-827a97c8"]])

export default __exports__